<template>
    <div class="estates-carousel">
        <my-carousel 
            :per-page-custom="perPageCustom" 
            :pagination-enabled="true"
            :scroll-per-page="true"
            :navigation-enabled="navigationEnabled"
            :navigation-next-label="'<span></span>'"
            :navigation-prev-label="'<span></span>'"
            :mouse-drag="false"
            @page-change="onPageChange"
            ref="carousel"
        >
            <slide
                v-for="estate in estates"
                :key="estate.id"
            >
                <estate-card
                    :estate="estate"
                    :carousel="false"
                />
            </slide>
            <!-- <template v-slot:pagination>
                <custom-pagination 
                    @paginationclick="goToPage($event, 'pagination')" 
                    :show-title="false" />
            </template> -->
        </my-carousel>
    </div>
</template>

<script>
import CustomPagination from '../CustomPagination'
import MyCarousel from '../MyCarousel'
import EstateCard from './Card'

export default {
    components:{
        'custom-pagination': CustomPagination,
        'estate-card': EstateCard,
        'my-carousel': MyCarousel,
    },

    props: {
        estates: {
            type: Array,
            required: true,
        },

        navigationEnabled: {
            type: Boolean,
            default: true,
        },

        perPageCustom: {
            type: Array,
            default() {
                return [[0, 1], [768, 2], [1100, 3], [1200, 4]]
            }
        },
    },

    data(){
        return {
            carousel: null,
        }
    },

    mounted(){
        this.$nextTick(() =>{
            this.carousel = this.$refs.carousel
        })
    },

    methods: {
        onPageChange(page) {
            window.events.$emit('prevent card click')
        },
        goToPage(page, type){
            if(this.carousel){
                this.carousel.goToPage(page, type)
            }
        }
        
    },

}
</script>
